import React, { Component } from "react";
//import InputRange from "../../../components/Common/inputRange";
import Datetime from "react-datetime";
import Input from "../../components/Common/input";
import { InputGroup } from "react-bootstrap";
//import Select from "../../../components/Common/select";

import { Col, Row } from "react-bootstrap";
class ListItemSearch extends Component {
  state = {};
  render() {
    const {
      handleChangeDate,
      handleChange,
      search,
      handleSubmitSearch,
      from,
    } = this.props;
    return (
      <Row>
        <Col md={3}>
          <Input
            onChange={handleChange}
            value={search.code}
            name="code"
            label="Item Code"
          />
        </Col>
        <Col md={2}>
          <Input
            onChange={handleChange}
            value={search.customer_code}
            name="customer_code"
            label="Customer Code"
          />
        </Col>
        <Col md={2}>
          <Input
            onChange={handleChange}
            value={search.description}
            name="description"
            label="Description"
          />
        </Col>
        {/* <Col md={3}>
          <Input
            onChange={handleChange}
            value={search.finishing}
            name="finishing"
            label="Item Finishing"
          />
        </Col> */}
        {/*
        <Col md={4}>
          <div className="form-group">
            <label htmlFor="tanggalMasuk">Tanggal Masuk</label>
            <InputGroup>
              <Datetime
                timeFormat={false}
                inputProps={{ placeholder: "Dari" }}
                defaultValue=""
                onChange={e => handleChangeDate(e, "scanFrom")}
              />
              <InputGroup.Addon>
                <i className="fa fa-minus" />
              </InputGroup.Addon>
              <Datetime
                timeFormat={false}
                inputProps={{ placeholder: "Sampai" }}
                defaultValue=""
                onChange={e => handleChangeDate(e, "scanTo")}
              />
            </InputGroup>
          </div>
        </Col> */}
        {/* <Col md={3}>
          <Input
            onChange={handleChange}
            value={search.no_bak}
            name="no_bak"
            label="No Bak"
          />
        </Col> */}
        {/* 
          <Col md={4}>
            <InputRange
              onChange={handleChange}
              value1={search.tonaseFrom}
              value2={search.tonaseTo}
              name1="tonaseFrom"
              name2="tonaseTo"
              label="Tonase"
            />
          </Col> */}
        <Col md={2} style={{ paddingTop: "25px" }}>
          <button
            className="btn btn-fill btn-success"
            onClick={handleSubmitSearch}
          >
            Search
          </button>
        </Col>
      </Row>
    );
  }
}

export default ListItemSearch;



// WEBPACK FOOTER //
// ./src/views/item/listItemSearch.jsx